import request from "../axios-instance";

/**
 * 행동과 함께 남길 원본 파일. 링크는 백엔드가 id 종류에 맞는 경로 규칙으로 만든다.
 * 그 자리에서 비교만 하고 버리는 업로드는 id 없이 파일명만 넘긴다.
 */
export interface UserActionFile {
  filename: string;
  ixdReportId?: string;
  dsdFileId?: string;
}

/**
 * 프론트 UI 이벤트(조회·페이지 이동 등 mutation 이 없는 행동)를 OKR 추적용으로
 * 백엔드에 기록한다. actionLabel 이 Slack 메시지 요약이 된다.
 * files 를 함께 주면 Slack 메시지에 파일명이 붙고, 저장된 원본이 있으면 대시보드
 * 링크가 걸린다. 대사처럼 파일을 둘 다루는 행동은 둘 다 넘긴다.
 * notify 를 false 로 주면 Slack 으로 보내지 않고 서버 로그에만 남긴다.
 * 로깅 실패가 사용자 흐름을 막지 않도록 에러는 삼킨다.
 */
export const logUserAction = async (
  actionLabel: string,
  files: UserActionFile[] = [],
  { notify = true }: { notify?: boolean } = {},
): Promise<void> => {
  try {
    await request.post("/v1/logs/user-action", { actionLabel, files, notify });
  } catch {
    // 행동 로깅 실패는 무시한다.
  }
};
